import { IParams } from '../..';

export const SALE_URBAN_ORDER: (keyof IParams)[] = [
  'undergroundTime',
  'area',
  'roomsTotal',
  'roomsInDeal',
  'layout',
  'ceilingHeight',
  'bathrooms',
  'repair',
  'floor',
  'floorsTotal',
  'windows',
  'houseYear',
  'houseMaterial',
  'demolishedInMoscowProgramm',
  'elevators',
  'parking',
  'saleType',
  'dwellingStatus',
  'publish',
  'wordsInclude',
  'wordsExclude',
  'phone',
  'offerId',
];
